import styled from 'styled-components';
import {Space} from 'antd';
import {typographyStyles} from '../../../../utils/styles';

const StyledInvoiceSelector = styled(Space)`
  width: 100%;

  .ant-btn-link {
    align-items: center;
    color: ${props => props.theme.colors.primary_6};
    display: flex;
    padding: 0;
  }
`;

const StyledInvoiceSelectorActionsSpace = styled(Space)`
  align-items: center;
  width: 100%;
  & > .ant-space-item {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

const StyledInvoiceSelectorBr = styled.div`
  text-align: center;
  width: 100%;

  &:before,&:after {
    background-color: ${props => props.theme.colors.neutral_4};
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: calc(100% / 2 - 15px);
  }
  &:before {
    right: 0.5em;
  }
  &:after {
    left: 0.5em;
  }
`;

const StyledInvoiceSelectorHeader = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  justify-content: space-between;

  .invoice-selector-header-date {
    ${typographyStyles.footnote.description};
    color: ${props => props.theme.colors.neutral_8};
  }

  .invoice-selector-header-amount {
    ${typographyStyles.heading.h4};
  }

  .invoice-selector-header-vendor {
    ${typographyStyles.body.regular};
  }
`;

const StyledInvoiceSelectorList = styled.div`
  min-height: 140px;
  max-height: 400px;
  overflow-y: auto;
`;

const StyledInvoiceSelectorMatchSpace = styled(Space)`
  justify-content: end;
  padding-top: 16px;
  width: 100%;
`;

export {
  StyledInvoiceSelector,
  StyledInvoiceSelectorActionsSpace,
  StyledInvoiceSelectorBr,
  StyledInvoiceSelectorHeader,
  StyledInvoiceSelectorList,
  StyledInvoiceSelectorMatchSpace,
};
